import { render, staticRenderFns } from "./SalesBstkDetail.vue?vue&type=template&id=1d173338"
import script from "./SalesBstkDetail.vue?vue&type=script&lang=js"
export * from "./SalesBstkDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports